import { BasePlayer } from './BasePlayer';
import { Html5Player } from './Html5Player';

export function getSmartPlayer(): BasePlayer {
  return new Html5Player();
}

export default getSmartPlayer;
